export default __webpack_public_path__ + "static/media/icon-agent-directory.14417360.svg";